<script lang="ts">
  import { put } from "@util/api"
  import ErrorMessage from "./ui/ErrorMessage.svelte"
  import Form from "./ui/Form.svelte"
  import SubmitButton from "./ui/SubmitButton.svelte"

  interface TripWithLimits {
    id: number
    registrationGoal: number | undefined
    participationLimit: number | undefined
  }
  export let trip: TripWithLimits
  export let updatePath: string
  export let editTripsAllowed: string

  let goalInput
  let limitInput

  let editingGoal = false
  let editingLimit = false

  function editGoal() {
    editingGoal = true
    setTimeout(() => goalInput.focus(), 0)
  }

  function editLimit() {
    editingLimit = true
    setTimeout(() => limitInput.focus(), 0)
  }

  function formatCount(limit: number | string | undefined) {
    if (limit !== undefined && limit !== "") {
      return limit.toString()
    } else {
      return "None"
    }
  }

  async function submitGoal() {
    let result = await put(updatePath, { trip })

    if (result.ok) {
      editingGoal = false
    }

    return result
  }

  async function submitLimit() {
    let result = await put(updatePath, { trip })

    if (result.ok) {
      editingLimit = false
    }

    return result
  }
</script>

<section class="section-setup" data-role="payment-schedule-section">
  <div class="header">
    <div class="py-2">
      <h2>Registration Minimum</h2>
      <p>The minimum number of passengers needed to make this trip financially feasible</p>
    </div>

    {#if editingGoal}
      <Form data={trip} submit={submitGoal} let:submitted let:submitting let:errors>
        <input
          type="text"
          class="w-16 text-right text-lg"
          data-role="registration-minimum-input"
          bind:this={goalInput}
          bind:value={trip.registrationGoal} />
        <ErrorMessage when={submitted} error={errors.registrationGoal} />

        <SubmitButton {submitting}>Save</SubmitButton>
      </Form>
    {:else}
      <div class="flex items-center gap-4">
        <div class="text-lger font-bold" data-role="registration-minimum-text">{formatCount(trip.registrationGoal)}</div>
        {#if editTripsAllowed == "true"}
          <button on:click={editGoal} class="button less-important" data-role="edit-registration-minimum">Edit</button>
        {/if}
      </div>
    {/if}
  </div>

  <div class="header">
    <div class="py-2">
      <h2>Registration Limit</h2>
      <p>The number of seats that are available on this trip. Subsequent travelers will be put on the waitlist</p>
    </div>

    {#if editingLimit}
      <Form data={trip} submit={submitLimit} let:submitted let:submitting let:errors>
        <input
          type="text"
          class="w-16 text-right text-lg"
          data-role="registration-limit-input"
          bind:this={limitInput}
          bind:value={trip.participationLimit} />
        <ErrorMessage when={submitted} error={errors.participationLimit} />

        <SubmitButton {submitting}>Save</SubmitButton>
      </Form>
    {:else}
      <div class="flex items-center gap-4">
        <div class="text-lger font-bold" data-role="registration-limit-text">{formatCount(trip.participationLimit)}</div>
        {#if editTripsAllowed == "true"}
          <button on:click={editLimit} class="button less-important" data-role="edit-registration-limit">Edit</button>
        {/if}
      </div>
    {/if}
  </div>
</section>
